"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var window_or_global_1 = __importDefault(require("window-or-global"));
function getDataAttribute(element, attributeName) {
    if (!element || !attributeName)
        return null;
    return element.dataset ? element.dataset[attributeName] : element.getAttribute("data-" + attributeName);
}
exports.getDataAttribute = getDataAttribute;
function setDataAttribute(element, attributeName, value) {
    if (!element || !attributeName || !value)
        return null;
    if (element.dataset) {
        element.dataset[attributeName] = value;
    }
    else {
        element.setAttribute("data-" + attributeName, value);
    }
    return 1;
}
exports.setDataAttribute = setDataAttribute;
function getWindowLocationOrigin() {
    if (!window_or_global_1.default.location.origin) {
        var port = window_or_global_1.default.location.port ? ":" + window_or_global_1.default.location.port : '';
        window_or_global_1.default.location.origin = window_or_global_1.default.location.protocol + "//" + window_or_global_1.default.location.hostname + port;
        return window_or_global_1.default.location.origin;
    }
    return window_or_global_1.default.location.origin;
}
exports.getWindowLocationOrigin = getWindowLocationOrigin;
exports.getWindowWidth = function () {
    var innerWindowWidth = window_or_global_1.default.innerWidth;
    var clientWidth = window_or_global_1.default.document.documentElement.clientWidth || window_or_global_1.default.document.getElementsByTagName('body')[0].clientWidth;
    if (clientWidth < innerWindowWidth) {
        return innerWindowWidth;
    }
    return clientWidth;
};
exports.getWindowHeight = function () {
    var innerHeight = window_or_global_1.default.innerHeight;
    var clientHeight = window_or_global_1.default.document.documentElement.clientHeight || window_or_global_1.default.document.getElementsByTagName('body')[0].clientHeight;
    if (clientHeight < innerHeight) {
        return innerHeight;
    }
    return clientHeight;
};
exports.getElement = function (elementParam) {
    if (!elementParam)
        return null;
    var element;
    if (typeof elementParam === 'string') {
        element = window_or_global_1.default.document.getElementById(elementParam) || null;
    }
    else if (typeof elementParam === 'object' && elementParam.offsetWidth) {
        element = elementParam;
    }
    else {
        console.warn('getElement() could not obtain an element from the parameter passed. Requires an ID or a DOM node.');
    }
    return element;
};
exports.getOuterWidth = function (elementParam) {
    var element = exports.getElement(elementParam);
    var getMargin = function (prop) {
        if (!element || !prop) {
            return 0;
        }
        var marginValue;
        try {
            if (window_or_global_1.default.getComputedStyle) {
                var style = window_or_global_1.default.getComputedStyle(element) || {};
                marginValue = style.getPropertyValue(prop) || 0;
            }
            else if (element.currentStyle) {
                marginValue = element.currentStyle[prop];
            }
        }
        catch (e) {
        }
        marginValue = marginValue.replace('px', '');
        return +marginValue;
    };
    var width = 0;
    if (element) {
        width = element.offsetWidth ? element.offsetWidth : 0;
        width += getMargin('margin-left');
        width += getMargin('margin-right');
    }
    return width;
};
exports.getInnerWidth = function (elementParam) {
    var element = exports.getElement(elementParam);
    var width = 0;
    if (element) {
        width = element.offsetWidth ? element.offsetWidth : 0;
    }
    return width;
};
function draggingMotion(e, mouseDown) {
    var allowed = 40;
    var x = e.clientX;
    var y = e.clientY;
    if (mouseDown) {
        if (Math.abs(x - mouseDown.x) > allowed) {
            return true;
        }
        if (Math.abs(y - mouseDown.y) > allowed) {
            return true;
        }
    }
    return false;
}
exports.draggingMotion = draggingMotion;
exports.getBowserState = function () {
    var mobile;
    var tablet;
    var msie;
    var firefox;
    var ios;
    var msedge;
    var mac;
    var linux;
    if (window_or_global_1.default._epicGamesNav && window_or_global_1.default._epicGamesNav.browser) {
        mobile = window_or_global_1.default._epicGamesNav.browser.mobile;
        tablet = window_or_global_1.default._epicGamesNav.browser.tablet;
        msie = window_or_global_1.default._epicGamesNav.browser.msie;
        firefox = window_or_global_1.default._epicGamesNav.browser.firefox;
        ios = window_or_global_1.default._epicGamesNav.browser.ios;
        msedge = window_or_global_1.default._epicGamesNav.browser.msedge;
        mac = window_or_global_1.default._epicGamesNav.browser.mac;
        linux = window_or_global_1.default._epicGamesNav.browser.linux;
    }
    return {
        mobile: mobile || false,
        tablet: tablet || false,
        msie: msie || false,
        firefox: firefox || false,
        ios: ios || false,
        msedge: msedge || false,
        mac: mac || false,
        linux: linux || false
    };
};
function isMobile() {
    var epicGamesNavInfo = window_or_global_1.default._epicGamesNav;
    var browser = epicGamesNavInfo.browser;
    return browser && browser.mobile;
}
exports.isMobile = isMobile;
function isTablet() {
    var epicGamesNavInfo = window_or_global_1.default._epicGamesNav;
    var browser = epicGamesNavInfo.browser;
    return browser && browser.tablet;
}
exports.isTablet = isTablet;
function getDecimalSeparator() {
    var decSep = '.';
    try {
        var decimalNumber = 3 / 2;
        var sep = parseFloat("" + decimalNumber)
            .toLocaleString()
            .substring(1, 2);
        if (sep === '.' || sep === ',') {
            decSep = sep;
        }
    }
    catch (e) {
        console.warn('Failed to detect the decimal separator');
    }
    return decSep;
}
exports.getDecimalSeparator = getDecimalSeparator;
function convertStringToNumber(numericString) {
    var decSeparator = getDecimalSeparator();
    var numeric;
    if (decSeparator === '.') {
        numeric = Math.floor(+numericString.replace(/,/, ''));
    }
    else if (decSeparator === ',') {
        numeric = Math.floor(+numericString.replace(/\./, ''));
    }
    else {
        numeric = Math.floor(+numericString);
    }
    return numeric;
}
exports.convertStringToNumber = convertStringToNumber;
//# sourceMappingURL=data:application/json;base64,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